import { GET_CHANNEL_TIMELINE } from '../../../../graphql/queries/channelTimeline';
import type {
  GetChannelTimelineQuery,
  GetChannelTimelineQueryVariables,
} from '../../../../types/graphql-generated';
import { PostFeed } from './PostFeed';
import { usePaginatedPosts } from '../utils/usePaginatedPosts';

// The channels timeline feed: the most recent published posts across all the
// channels the user follows, newest first, with pull-to-refresh and infinite
// scroll pagination.
export const ChannelTimeline = () => {
  const feed = usePaginatedPosts<GetChannelTimelineQuery, GetChannelTimelineQueryVariables>(
    GET_CHANNEL_TIMELINE,
    'channelTimeline',
    {},
  );

  return (
    <PostFeed {...feed} emptyMessage="Aún no hay publicaciones en los canales que sigues" />
  );
};
